import Vue from 'vue'

import ProductList from '@/components/thorvik/catalog/ProductList'
import ProductImages from '@/components/thorvik/catalog/ProductImages'

import BuyButton from "@/components/catalog/BuyButton";

import ProductSlider from "@/components/catalog/ProductSlider";
import ProductMultiSlider from "@/components/catalog/ProductMultiSlider";

import TopCatalog from "@/components/thorvik/catalog/TopCatalog";
import SearchString from "@/components/thorvik/catalog/SearchString";

import ContactForm from "@/components/thorvik/customer/ContactForm";

import MenuButton from "@/components/customer/MenuButton";
import MenuFloat from "@/components/customer/MenuFloat";


import WhereToBuy from "@/components/thorvik/customer/WhereToBuy";

import ContactMap from "@/components/customer/ContactMap";


import OfficeMap from "@/components/core/OfficeMap.vue";

import FaqForm from "@/components/core/FaqForm";
import FaqLink from "@/components/core/FaqLink.vue";



import bFormSlider from 'vue-bootstrap-slider';
import underscore from 'vue-underscore'
import VueResource from 'vue-resource'
import VModal from 'vue-js-modal'
import YmapPlugin from 'vue-yandex-maps'
import VueWaypoint from "vue-waypoint/src";

import SwiperCore, { Navigation, Pagination } from 'swiper';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

// Install modules
SwiperCore.use([Navigation, Pagination]);

Vue.use(YmapPlugin, {
    apiKey: 'efa45a74-34c6-4532-aa40-25baa3a1babd',
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1'
})

Vue.use(VModal, { dialog: true, dynamic: true})
Vue.use(underscore)
Vue.use(VueResource)
Vue.use(VueWaypoint)
Vue.use(bFormSlider)

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
AOS.init();

Vue.config.productionTip = false
Vue.prototype.$log = window.console.log
Vue.prototype.$scrollToTop = () => window.scrollTo(0,0)

import './filters'

// import './assets/libs/boostrap_slider/boostrap_slider.min.css'
// import './assets/libs/select2/select2.min.css'
// import './assets/libs/slick/slick.css'
// import './assets/libs/swiper/swiper.min.css'

import 'bootstrap-slider/dist/css/bootstrap-slider.css'



import './assets/css/fillinn.scss'

import { store } from './store'



// Vue.directive('select2', {
//     twoWay: true,
//     bind: function (el) {
//         window.$(el).select2().on("select2:select", (e) => {
//             el.dispatchEvent(new Event('change', { target: e.target }));
//         });
//         window.$(el).select2().on("select2:unselect", (e) => {
//             el.dispatchEvent(new Event('change', { target: e.target }));
//         });
//         window.$(el).select2().on("select2:clear", (e) => {
//             el.dispatchEvent(new Event('change', { target: e.target }));
//         });
//     },
// });

Vue.http.interceptors.push( (request, next) => {
    // continue to next interceptor
    next( (response) => {
        if (response.status == 401) {
            if(response.url != '/login'){
                window.location.href='/customer/login-form'
            }
            window.console.log(response);
            return
        }
        if (response.status == 403) {
            window.console.log('403 code');
        }
        if (response.status == 500 || response.status == 502 || response.status == 504 ) {
            if(response.body && response.body.message){
                Vue.prototype.$modal.show('dialog', {
                    title: 'Ошибка',
                    text: response.body.message,
                    buttons: [
                        {
                            title: 'Закрыть',
                            handler: () => Vue.prototype.$modal.hide('dialog')
                        }
                    ]
                })
//                alert(response.body.message);
            }
            window.console.log(response);
            // eventBus.$emit('global.wrong.response', response.body.message);
        }
    })
})


new Vue({
    components: {
        ProductList,
        BuyButton,

        ProductSlider,
        ProductMultiSlider,
        ProductImages,

        TopCatalog,

        ContactMap,

        SearchString,

        MenuButton,
        MenuFloat,

        WhereToBuy,

        OfficeMap,
        FaqForm,
        FaqLink,

        ContactForm
    },
    store
}).$mount('#app')